<template>
    <div :id="container"></div>
</template>

<script>
import {Html5Qrcode} from "html5-qrcode";

export default {
    props: ['container'],
    //template: "<div id='"+container+"'></div>",
    data() {
        return {
            html5QrCode: null
        }
    },
    created() {

    },
    mounted() {
        this.html5QrCode = new Html5Qrcode(this.container);
        this.start();
    },
    methods: {
        onScanSuccess (decodedText, decodedResult) {
            this.$emit('result', decodedText, decodedResult);
        },
        start() {
            if (!this.html5QrCode.isScanning) {
                let config = { fps: 10, qrbox: { width: 250, height: 250 } };
                this.html5QrCode.start({ facingMode: "environment" }, config, this.onScanSuccess);
            }
        },
        stop() {
            if (this.html5QrCode.isScanning) {
                this.html5QrCode.stop().then((ignore) => {})
                .catch((err) => {});
            }
        }
    },
}
</script>
